import { render, staticRenderFns } from "./alterPhone.vue?vue&type=template&id=f0a8a4ea&scoped=true&"
import script from "./alterPhone.vue?vue&type=script&lang=js&"
export * from "./alterPhone.vue?vue&type=script&lang=js&"
import style0 from "./alterPhone.vue?vue&type=style&index=0&id=f0a8a4ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a8a4ea",
  null
  
)

export default component.exports